import React from "react";

const Newsletter = () => {
  return (
    <div className="newsletter">
      <div className="newsletter_main container flex-col-center">
        <h2 className="dc-script">Newsletter</h2>
        <h1 className="dc-script">Get Discount 30% Off</h1>
        <div className="shadow-sm">
          <input type="text" placeholder="Enter your email address" />
          <button>Subscribe</button>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
